import { render, staticRenderFns } from "./CategoryChooser.vue?vue&type=template&id=b9ac53aa&"
import script from "./CategoryChooser.vue?vue&type=script&lang=js&"
export * from "./CategoryChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports